import React from "react";
import { AlertTriangle } from "lucide-react";
import { cn } from "@/lib/utils";

/**
 * The line a list row wears under its status while an undo request is awaiting
 * approval. The server refuses every status change on that application until it
 * is decided, so the row says why it will not move. One definition for every
 * list that shows applications, so they say it the same way.
 */
const UndoPendingTag = ({ className }) => (
  <span className={cn("mt-1 flex items-center justify-center gap-1 whitespace-nowrap text-[11px] font-medium text-text-primary", className)}>
    <AlertTriangle size={12} className="shrink-0 text-warning" aria-hidden="true" />
    Undo Request Pending
  </span>
);

export default UndoPendingTag;
